import { useAboutByAppName } from '../hooks';
import { FC, useEffect } from 'react';
import { generateTextArt, useEnvironment } from '@xanectech/lib';

const logo = `
██╗  ██╗ █████╗ ███╗   ██╗███████╗ ██████╗
 ██║██║ ██╔══██╗████╗  ██║██╔════╝██╔════╝
  ███║  ███████║██╔██╗ ██║█████╗  ██║   
 ██║██║ ██╔══██║██║╚██╗██║██╔══╝  ██║   
██║  ██║██║  ██║██║ ╚████║███████╗╚██████╗
╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝╚══════╝ ╚═════╝ 
`;

export interface AboutLoggerProps {
  appName?: string;
}

export const AboutLogger: FC<AboutLoggerProps> = ({ appName }) => {
  const { data, error } = useAboutByAppName(appName || '');
  const environment = useEnvironment();

  const appArt = appName ? generateTextArt(appName) : '';

  useEffect(() => {
    if (data) {
      console.clear();

      console.info(
        `%c${logo}`,
        'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
      );

      // console.info(
      //   `%c${appArt}`,
      //   'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
      // );

      // console.info(
      //   `%c${appArt}`,
      //   'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 10px; text-align: center;',
      // );

      console.groupCollapsed(
        `%cAbout ${appName || ''}%c`,
        'background-color: HSL(210, 100%, 58%); font-size: 14px; color: white; font-weight: bold; padding: 10px 80px; border: 1px solid HSL(210, 100%, 58%); min-width: 100vw; text-align: center;',
        '',
      );

      if (environment.loggingVars.VITE_DEV) {
        console.warn(
          '%cMode\n%c',
          'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
          'color: white; font-size: 12px;',
          'Development',
        );
      }

      console.info(
        '%cVersion\n%c',
        'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
        'color: white; font-size: 12px;',
        data.version,
      );
      console.info(
        '%cRelease Date\n%c',
        'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
        'color: white; font-size: 12px;',
        data.release_date,
      );
      console.info(
        '%cCopyright\n%c',
        'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
        'color: white; font-size: 12px;',
        data.copyright,
      );
      console.info(
        '%cTerms of Service\n%c',
        'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
        'color: white; font-size: 12px;',
        data.terms_of_service,
      );
      console.info(
        '%cPrivacy Policy\n%c',
        'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
        'color: white; font-size: 12px;',
        data.privacy_policy,
      );

      console.info(
        '%cContact Email\n%c',
        'color: HSL(210, 100%, 58%); font-weight: bold; font-size: 12px; text-align: center;',
        'color: white; font-size: 12px;',
        data.info_email,
      );
      console.groupEnd();
    }
  }, [data, appArt, appName, environment.loggingVars.VITE_DEV]);
  return null;
};
